import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Snackbar, SnackbarContent, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/CheckCircleOutline';

import * as SnackbarActions from '../../actions/snackbar';

const styles = {
  success: {
    backgroundColor: 'green',
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
};

function SnackbarSuccess(props) {
  const dispatch = useDispatch();
  const { successSnackbarMessage, successSnackbarOpen } = useSelector(
    (state) => state.snackbar,
  );

  function handleClose() {
    dispatch(SnackbarActions.clearSnackbar());
  }

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      open={successSnackbarOpen}
      autoHideDuration={6000}
      onClose={handleClose}
    >
      <SnackbarContent
        style={styles.success}
        message={(
          <span id="message-id" style={styles.message}>
            <CheckIcon style={{ ...styles.icon, ...styles.iconVariant }} sx={{ mr: 2 }} />
            {successSnackbarMessage}
          </span>
        )}
        action={[
          <IconButton
            key="close"
            aria-label="Close"
            color="inherit"
            onClick={handleClose}
          >
            <CloseIcon style={styles.icon} />
          </IconButton>,
        ]}
      />
    </Snackbar>
  );
}

export default SnackbarSuccess;
